/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoItemBoxOpenLogListListData model module.
 * @module model/LogControllerDtoItemBoxOpenLogListListData
 * @version 1.0
 */
class LogControllerDtoItemBoxOpenLogListListData {
    /**
     * Constructs a new <code>LogControllerDtoItemBoxOpenLogListListData</code>.
     * @alias module:model/LogControllerDtoItemBoxOpenLogListListData
     */
    constructor() { 
        
        LogControllerDtoItemBoxOpenLogListListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoItemBoxOpenLogListListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoItemBoxOpenLogListListData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoItemBoxOpenLogListListData} The populated <code>LogControllerDtoItemBoxOpenLogListListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoItemBoxOpenLogListListData();

            if (data.hasOwnProperty('openNo')) {
                obj['openNo'] = ApiClient.convertToType(data['openNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('reward')) {
                obj['reward'] = ApiClient.convertToType(data['reward'], 'String');
            }
            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoItemBoxOpenLogListListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoItemBoxOpenLogListListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['reward'] && !(typeof data['reward'] === 'string' || data['reward'] instanceof String)) {
            throw new Error("Expected the field `reward` to be a primitive type in the JSON string but got " + data['reward']);
        }

        return true;
    }


}



/**
 * @member {Number} openNo
 */
LogControllerDtoItemBoxOpenLogListListData.prototype['openNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoItemBoxOpenLogListListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} itemId
 */
LogControllerDtoItemBoxOpenLogListListData.prototype['itemId'] = undefined;

/**
 * @member {Number} itemCount
 */
LogControllerDtoItemBoxOpenLogListListData.prototype['itemCount'] = undefined;

/**
 * @member {String} reward
 */
LogControllerDtoItemBoxOpenLogListListData.prototype['reward'] = undefined;

/**
 * @member {Number} transactionNo
 */
LogControllerDtoItemBoxOpenLogListListData.prototype['transactionNo'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoItemBoxOpenLogListListData.prototype['createdAt'] = undefined;






export default LogControllerDtoItemBoxOpenLogListListData;

